export default __webpack_public_path__ + "static/media/chevron-up.6d034bd2.svg";